const API = '/souche/api';
const SEAL = '/api/txs';

const api = {
  login: `${API}/login`,
  logout: `${API}/logout`,
  imgUrl: `${API}/captcha.jpg`,
  register: `${API}/user-info`,
  sysRole: `${API}/sys-role`,
  roleStatus: `${API}/sys-role/role/statues`,
  getRole: `${API}/sys-role`,
  changePerm: `${API}/rolePerm/update`,
  getUserInfo: `${API}/user-info`,
  changeRoleType: `${API}/user-role/update`,
  useInfoStatus: `${API}/user-info/statues`,
  queryProductList: `${API}/assets/essentials`,
  queryProductDetails: `${API}/assets/get`,
  queryRepayMent: `${API}/repayment`,
  queryTransferList: `${API}/assets/transfer`,
  queryOverdueList: `${API}/repayment/get`,
  queryAssetsList: `${API}/assets/get`,
  queryRepeatList: `${API}/assets/duplicate`,
  queryTransferRecord: `${API}/assets/duplicate`,
  queryChart1: `${API}/analyse/chart-1`,
  queryText: `${API}/analyse`,
  queryChart2: `${API}/analyse/chart-2`,
  queryChart3: `${API}/analyse/chart-3`,
  queryChart4: `${API}/analyse/chart-4`,
  queryChart5: `${API}/analyse/chart-5`,
  queryChart6: `${API}/analyse/chart-6`,
  queryWarning: `${API}/warning`,
  queryWarningQuery: `${API}/warning/query`,
  queryEmailList: `${API}/user-messaging/user-email-list`,
  queryEmailWarningClose: `${API}/user-messaging/close-email-warning`,
  queryEmailWarningOpen: `${API}/user-messaging/open-email-warning`,
  changePassword: `${API}/reset-pwd`,
  createRole: `${API}/sys-role`,
  createUser: `${API}/user-info`,
  queryMailContext: `${API}/mail-context`,
  userGetRole: `${API}/user-role/role`,
  getJournalList: `${API}/logs`,
  getUrl: `${API}/url`,
  
  queryDataList: `${API}/d2d/native`,
  getonlineHash: `${SEAL}/summary`,
  assetsExport: `${API}/assets/getExport`,
  duplicateExport: `${API}/assets/duplicateExport`,
  queryOption: `${API}/assets/products`,
  download: `${API}/attachment/download`
}

export default api;